export default __webpack_public_path__ + "static/nmn-award-2023-dark-24fa79cf6d4ea613f5aa7ed2f68ee543.svg";